import request from '@/utils/request';
import axios from 'axios';

// 分页查询上课记录
export function getStudentAttendListApi(params) {
    return request({
        url: `/system/study/center/getStudentAttendList`,
        method: 'get',
        params
    })
}

//获取学员所有产品包
export function getPackageListApi() {
    return request({
        url: `/system/study/center/getPackageList`,
        method: 'get',
    })
}

//取学员某个产品包下的所有课程
export function getCourseListApi(params) {
    return request({
        url: `/system/study/center/getCourseList`,
        method: 'get',
        params
    })
}


//获取学习信息（去学习）
export function getStudentStudyDataApi(orderDetailId,objectivesId) {
    return request({
        url: `/system/study/center/chapter/getStudentStudyData/${orderDetailId}/${objectivesId}`,
        method: 'get',
        params
    })
}

//获取学习信息（去学习）
export function getChapterStudentStudyDataApi(orderDetailId,objectivesId) {
    return request({
        url: `/system/study/center/chapter/getStudentStudyData/${orderDetailId}/${objectivesId}`,
        method: 'get',
    })
}

//获取直播回放章节
export function getChapterListApi(orderDetailId) {
    return request({
        url: `/system/study/center/chapter/getChapterList/${orderDetailId}`,
        method: 'get',
    })
}


//根据素材ids获取素材信息
export function getFileDataByFileIdsApi(ids) {
    return request({
        url: `/system/study/center/chapter/getFileDataByFileIds`,
        method: 'post',
        data: ids
    })
}

//下载素材文件
export function chapterDownloadApi(fileId) {
    return request({
        url: `/system/study/center/chapter/download/${fileId}`,
        method: 'get',
        responseType: 'blob',
    })
}

//文件下载hooks
export function useDownloadFile () {
    const cancelTokenSource = ref({});
    const chunkSize = 1024 * 1024 * 5;
    //下载文件素材
    async function downloadFile (id, totalSize, callback) {
        cancelTokenSource.value[id] = axios.CancelToken.source();
        const chunkCount = Math.ceil(totalSize / chunkSize);
        const chunks = [];
        try {
            for (let i = 0; i < chunkCount; i++) {
                if (!cancelTokenSource.value[id]) break;
                const start = i * chunkSize;
                const end = Math.min(start + chunkSize - 1, totalSize - 1);
                const res = await request({
                    url: `/system/study/center/chapter/download/${id}`,
                    method: 'get',
                    headers: { 'Content-Type': 'application/octet-stream', 'Range': `bytes=${start}-${end}`, repeatSubmit: false, },
                    responseType: 'arraybuffer',
                    cancelToken: cancelTokenSource.value[id].token,
                    onDownloadProgress: (progressEvent) => {
                        const loaded = progressEvent.loaded + i * chunkSize;
                        callback && callback(loaded)
                    }
                });
                chunks.push(res)
            }
            const totalLength = chunks.reduce((acc, chunk) => acc + chunk.byteLength, 0);
            // 创建新的ArrayBuffer
            const result = new Uint8Array(totalLength);
            let offset = 0;
            // 合并所有分块
            for (const chunk of chunks) {
                result.set(new Uint8Array(chunk), offset);
                offset += chunk.byteLength;
            }
            return result.buffer;
        } catch {
            throw new Error('下载失败')
        }
    }
    //下载视频文件
    async function downloadVideo (url, id, callback) {
        cancelTokenSource.value[id] = axios.CancelToken.source();
        const headResponse = await axios.head(url);
        const totalSize = parseInt(headResponse.headers['content-length'], 10);
        const chunkCount = Math.ceil(totalSize / chunkSize);
        const chunks = [];
        try {
            for (let i = 0; i < chunkCount; i++) {
                if (!cancelTokenSource.value[id]) break;
                const start = i * chunkSize;
                const end = Math.min(start + chunkSize - 1, totalSize - 1);
                const res = await axios({
                    url,
                    method: 'get',
                    responseType: 'arraybuffer',
                    headers: { 'Range': `bytes=${start}-${end}` },
                    cancelToken: cancelTokenSource.value[id].token,
                    onDownloadProgress: (progressEvent) => {
                        const loaded = progressEvent.loaded + i * chunkSize;
                        callback && callback(loaded)
                    }
                })
                chunks.push(res.data)
            }
            const totalLength = chunks.reduce((acc, chunk) => acc + chunk.byteLength, 0);
            // 创建新的ArrayBuffer
            const result = new Uint8Array(totalLength);
            let offset = 0;
            // 合并所有分块
            for (const chunk of chunks) {
                result.set(new Uint8Array(chunk), offset);
                offset += chunk.byteLength;
            }
            return result.buffer;
        } catch {
            throw new Error('下载失败')
        }
    }
    //开始下载
    function saveAs (blob, fileName) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.setAttribute('target', '_self');
        link.setAttribute('style', 'display:none');
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }, 500);
    }
    //取消下载当前文件
    function cancenlDowload (id) {
        if (cancelTokenSource.value[id]) {
            cancelTokenSource.value[id].cancel('下载已取消');
            Reflect.deleteProperty(cancelTokenSource.value, id)
        }
    }
    return {
        downloadFile,
        downloadVideo,
        cancenlDowload,
        saveAs,
    }
}

//随堂练习 开始考试
export function inClassExercisesExamdApi(params = {}) {
    return request({
        url: `/system/exam/inClassExercises/preBeginExam`,
        method: 'get',
        params
    })
}


//知识点练习 开始考试
export function appointExamdApi(teachObjectiveId) {
    return request({
        url: `/system/keyPointExercises/appoint/preBeginExam`,
        method: 'get',
        params:{
            teachObjectiveId
        }
    })
}


// ---------------网校迁移V3.3-学习中心/做题记录/作业考试通知 -----------------------

// 省市区地址
export function getAddressApi(subjectClassTimeId) {
  return request({
    url: `/system/study/center/chapter/class/city/${subjectClassTimeId}`,
    method: 'get',
  });
}

// 获取校区列表

export function getSchoolListApi(data) {
  return request({
    url: `/system/study/center/chapter/class/campus`,
    method: 'post',
    data
  });
}

// 预约课程
export function bookingCourseApi(subjectClassTimeId, classId,courseId, bookingStatus) {
    return request({
        url: `/system/study/center/chapter/class/booking/${subjectClassTimeId}/${classId}/${courseId}/${bookingStatus}`,
        method: 'get',
    })
}

//学习中心-面授课校区查询
export function faceCourseCampusApi(subjectClassTimeId,type) {
    return request({
        url: `/system/study/center/chapter/class/campus/${subjectClassTimeId}/${type}`,
        method: 'get',
    })
}

//上课记录
export function courseRecordPageApi(data,params) {
    return request({
        url: `/system/study/center/chapter/course/record/Page`,
        method: 'post',
        data,
        params
    })
}

//上课通知-直播课列表查询
export function livingCourseApi(data) {
    return request({
        url: `/system/study/center/chapter/class/course/living/list`,
        method: 'post',
        data
    })
}

//历史直播
export function historyLivingApi(data,params) {
    return request({
        url: `/system/study/center/chapter/class/course/historyLiving/list`,
        method: 'post',
        data,
        params
    })
}

//上课通知 - 面授课分页查询
export function faceCoursePageApi(data,params) {
    return request({
        url: `/system/study/center/chapter/class/campus/page`,
        method: 'post',
        data,
        params
    })
}

//获取学员所有产品包 app端接口
export function getAppPackageListApi(data) {
    return request({
        url: `/system/study/center/getAppPackageList`,
        method: 'post',
        data
    })
}

//获取产品分类
export function getProductCategoryListApi() {
    return request({
        url: `/system/study/center/getProductCategoryList`,
        method: 'get',
    })
}

//获取产品分类-二级菜单
export function getProductCategoryDetailListApi(productCategoryId) {
    return request({
        url: `/system/study/center/getProductCategoryDetailList/${productCategoryId}`,
        method: 'get',
    })
}

//获取学员未购买产品包
export function getStudentUnPurchasePackageListApi(data,params) {
    return request({
        url: `/system/study/center/getStudentUnPurchasePackageList`,
        method: 'post',
        data,
        params
    })
}


//取学员某个产品包下的所有课程-未购买
export function getUnPurchaseCourseListApi(params) {
    return request({
        url: `/system/study/center/getUnPurchaseCourseList`,
        method: 'get',
        params
    })
}


//获取随堂练习、课后测、章节测、家庭作业数据
export function getclassTimeExamInfoApi (params) {
    return request({
        url: '/system/study/center/chapter/class/time/examInfo',
        method: 'post',
        params
    })
}
//我的课程，获取课程类型接口
export function getMyCourseTypeListApi(params) {
    return request({
        url: `/system/study/center/getMyCourseTypeList`,
        method: 'get',
        params
    })
}

//获取我的课程列表
export function getMyCourseListApi(data) {
    return request({
        url: `/system/study/center/getMyCourseList`,
        method: 'post',
        data
    })
}


export function getProductPackageListApi(data) {
    return request({
        url: `/system/study/center/getProductPackageList`,
        method: 'post',
        data
    })
}


export function getPracticalTrainingListApi(subjectId) {
    return request({
        url: `/system/study/center/practicalTraining`,
        method: 'get',
        params:{
            subjectId
        }
    })
}

// 点击账套后--多选一模式--选择行业--提交
export function saveIndustryZT(params) {
  return request({
    url: `/system/study/center/chooseIndustry`,
    method: 'post',
    params
  })
}
